import React from 'react';

export default function RegistrationSteps(props) {
  return (
    <ul className="registrationSteps">
      <li className="registrationSteps__item">
        <div className='registrationSteps__itemInner'>
          <i class="fas fa-check-circle"></i>
          <h3>
            CREATE ACCOUNT
          </h3>
        </div>
      </li>
      <li className="registrationSteps__item">
        <div className='registrationSteps__itemInner'>
          <i class="far fa-circle"></i>
          <h3>
            Post a job
          </h3>
        </div>
        <p className="registrationSteps__itemText">
          Enter details about your job and set the rate you want to pay
        </p>
      </li>
      <li className="registrationSteps__item">
        <div className='registrationSteps__itemInner'>
          <i class="far fa-circle"></i>
          <h3>
            Hire
          </h3>
        </div>
        <p className="registrationSteps__itemText">
          Review and approve your applications
        </p>
      </li>
      <li className="registrationSteps__item">
        <div className='registrationSteps__itemInner'>
          <i class="far fa-circle"></i>
          <h3>
            Pay
          </h3>
        </div>
        <p className="registrationSteps__itemText">
          You only pay after your job has been worked and completed
        </p>
      </li>
    </ul>
  )
}